import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';

export default class EndDialogBtn extends Phaser.GameObjects.Container {
  constructor(scene, btnName) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;

    this.btnValue = btnName;
    const txt = ABCyaPhaser.Text.addText(0, 0, 50, '0x515152', FontKeys._odin_roundedregular, this.btnValue, this);

    this.hitShape = ABCyaPhaser.Graphics.addRect(-txt.width / 2, -txt.height / 2, txt.width,txt.height, '0x000000', this, { x: 0, y: 0 }, true, true).setAlpha(.01);

    // this.setSize(hitShape.width, hitShape.height);
    this.isSelected = false;

    // this.setInteractive();
  }

  cleanUpPoints() {
    if (this.parentContainer) super.destroy();
  };
}